import { useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

type StatusGetInfoSolicitudCATAFuego = {
    status: number | null;
    statusText: string | null;
};

const getBackendMessage = (error: any) => {
    const responseData = error?.response?.data;
    return (
        (typeof responseData === 'string' ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        error?.response?.statusText ||
        error?.message ||
        'Error'
    );
};

const useGetInfoSolicitudCATAFuego = () => {
    const [loadingGetInfoSolicitudCATAFuego, setLoadingGetInfoSolicitudCATAFuego] = useState(false);
    const [successGetInfoSolicitudCATAFuego, setSuccessGetInfoSolicitudCATAFuego] = useState(false);
    const [errorGetInfoSolicitudCATAFuego, setErrorGetInfoSolicitudCATAFuego] = useState<any>(null);
    const [dataGetInfoSolicitudCATAFuego, setDataGetInfoSolicitudCATAFuego] = useState<any>(null);
    const [statusGetInfoSolicitudCATAFuego, setStatusGetInfoSolicitudCATAFuego] = useState<StatusGetInfoSolicitudCATAFuego>({
        status: null,
        statusText: null,
    });

    const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
    const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
    const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

    const getInfoSolicitudCATAFuego = async (userId: string, callback?: (data: any) => void) => {
        setLoadingGetInfoSolicitudCATAFuego(true);
        setSuccessGetInfoSolicitudCATAFuego(false);
        setErrorGetInfoSolicitudCATAFuego(null);

        try {
            const response = await apiRecord.getInfoSolicitudCataFmIncendio(userId);
            setStatusGetInfoSolicitudCATAFuego({
                status: response.status,
                statusText: response.statusText ?? response.response ?? null,
            });
            setSuccessGetInfoSolicitudCATAFuego(true);
            setDataGetInfoSolicitudCATAFuego(response.data);
            callback?.(response.data);
            return response.data;
        } catch (error: any) {
            setStatusGetInfoSolicitudCATAFuego({
                status: error?.response?.status || 500,
                statusText: getBackendMessage(error),
            });
            setErrorGetInfoSolicitudCATAFuego(error);
            throw error;
        } finally {
            setLoadingGetInfoSolicitudCATAFuego(false);
        }
    };

    return {
        getInfoSolicitudCATAFuego,
        loadingGetInfoSolicitudCATAFuego,
        successGetInfoSolicitudCATAFuego,
        errorGetInfoSolicitudCATAFuego,
        dataGetInfoSolicitudCATAFuego,
        statusGetInfoSolicitudCATAFuego,
    };
};

export default useGetInfoSolicitudCATAFuego;